import EcoLink from 'eco-design/base/eco-link';
import FooterAccessibility from 'eco-design/section-layout/ef-nav-common/FooterComps/FooterAccessibility';
import './index.scss';

export default function FooterC1Links({ locale, TextA = {}, theme = 'black' }: { locale: string; TextA: any; theme: 'white' | 'black' | 'gray' }) {
    const items = TextA?.privacyTerms || [];
    return (
        <>
            {items?.length > 0 && (
                <div className={`footer-FooterC1Links footer-FooterC1Links-theme-${theme}`}>
                    {items.map((item: { text: string; link: string }, index: number) => (
                        <EcoLink
                            className="footer-FooterC1Links-item GtmModuleData-btn-href"
                            key={index}
                            href={item.link}
                            aria-label={item.text}
                            target="_blank"
                            dataLayer={{
                                __btn_id1: 'footer-FooterC1Links',
                                __btn_id2: item.link,
                                __btn_type: 'href',
                            }}
                        >
                            {item.text}
                        </EcoLink>
                    ))}
                    <FooterAccessibility locale={locale} />
                </div>
            )}
        </>
    );
}
